"use client";

import React from "react";
import { renderMixedContent } from "../lib/renderContentUtils";

interface ProblemContentRendererProps {
  content: string;
  componentId: string;
}

const ProblemContentRenderer: React.FC<ProblemContentRendererProps> = ({
  content,
  componentId,
}) => {
  return (
    <>
      {renderMixedContent(content, {
        componentId,
        enableDebug: true,
        inProblem: true,
      })}
    </>
  );
};

export default ProblemContentRenderer;
